export const redirectToLogin = ()=>{
    window.location.href = '/login';
    localStorage.clear();
    sessionStorage.clear();
}